import React from 'react';
import PropTypes from 'prop-types';

const STYLE_PREFIX = 'c-consent-modal';

const ConsentCell = ({ children }) => {
  return <td className={`${STYLE_PREFIX}__consent-table-item`}>{children}</td>;
};

ConsentCell.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ConsentCell;
